<script setup lang="ts">
   defineProps<{
      html: string;
   }>();
</script>

<template>
   <div class="tournament-entry-html-block my-3" v-html="html" />
</template>

<style scoped>
   /* v-html content can't carry Tailwind utility classes, so style the sanitized
      HTML the API returns via :deep() — this is the one place custom CSS is needed. */
   .tournament-entry-html-block :deep(h2) {
      font-size: 1.5rem;
      line-height: 1.25;
      font-weight: 700;
      margin-top: 1.5rem;
      margin-bottom: 0.75rem;
      color: #111827;
   }

   .tournament-entry-html-block :deep(h3) {
      font-size: 1.125rem;
      font-weight: 600;
      margin-top: 1.25rem;
      margin-bottom: 0.5rem;
      color: #1f2937;
   }

   .tournament-entry-html-block :deep(p) {
      font-size: 0.95rem;
      line-height: 1.6;
      margin-bottom: 0.75rem;
      color: #374151;
   }

   .tournament-entry-html-block :deep(ul) {
      list-style: none;
      padding-left: 0;
      margin-bottom: 0.75rem;
      color: #374151;
   }

   .tournament-entry-html-block :deep(ol) {
      margin-left: 1.5rem;
      margin-bottom: 0.75rem;
      color: #374151;
   }

   .tournament-entry-html-block :deep(ul li) {
      position: relative;
      padding-left: 1.5rem;
      margin-bottom: 0.5rem;
   }

   .tournament-entry-html-block :deep(ol li) {
      margin-bottom: 0.25rem;
   }

   .tournament-entry-html-block :deep(ul li::before) {
      content: '';
      position: absolute;
      left: 0.25rem;
      top: 0.6rem;
      width: 0.4rem;
      height: 0.4rem;
      border-radius: 9999px;
      background-color: var(--lms-color-brand-primary);
   }

   /* The API can return <li><p>...</p></li>; strip the inner <p> margins so the
      dot aligns with the text instead of the paragraph's top margin. */
   .tournament-entry-html-block :deep(ul li p),
   .tournament-entry-html-block :deep(ol li p) {
      margin: 0;
   }

   .tournament-entry-html-block :deep(blockquote) {
      border-left: 3px solid #d1d5db;
      padding-left: 1rem;
      color: #4b5563;
      font-style: italic;
      margin: 0.75rem 0;
   }

   .tournament-entry-html-block :deep(a) {
      color: #2563eb;
      text-decoration: underline;
   }

   .tournament-entry-html-block :deep(strong) {
      font-weight: 600;
   }
</style>
